import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { UserComponent } from '../user/user.component';
import { TranslateService } from '@ngx-translate/core';
import { BranchAuthComponent } from '../branch-auth/branch-auth.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  public menu_item_id = '6';
  public add_auth;
  public edit_auth;
  public del_auth;
  can_add = true;

  branchList = [];
  private dp = [];
  user_info = [];
  base_info = [];
  displayedColumns = ['name', 'user_name', 'branch_name', 'baseline_amount', 'branch_auth', 'change_pass', 
    'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<UserComponent>;
  authDialogRef: MatDialogRef<BranchAuthComponent>;
  changeDialogRef: MatDialogRef<ChangePasswordComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'user', 'name': '', 'branch_id': '0' };

  Success_Msg; Error_Msg; Del_Msg; Not_Casher;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Not_Casher').subscribe((res: string) => {
      this.Not_Casher = res;
    });
  }

  ngOnInit() {
    if (this.applicationConstants.user_info.role == 'admin') 
      this.displayedColumns = ['name', 'user_name', 'branch_name', 'baseline_amount', 'branch_auth', 
        'change_pass', 'edit', 'del'];
    else 
      this.displayedColumns = ['name', 'user_name', 'branch_name', 'baseline_amount', 'branch_auth', 
        'edit', 'del'];

    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = this.queryList.all_branch;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    this.checkUserCount();
  }

  checkUserCount() {
    let query = "SELECT COUNT(*) as `user_count` FROM `user` WHERE `user_name` != 'mas'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let user_count = data.data['list'][0]['user_count'];
        this.can_add = (Number(user_count) < Number(this.utils.getParamValue('user_count')));
      });
  }

  search() {
    this.dp = [];
    let condition = "";

    if (this.model['name'] != '')
      condition += " AND (`user`.`user_name` LIKE '%" + this.model['name'] + "%' OR `employee`.`name` LIKE '%" +
        this.model['name'] + "%'  OR `employee`.`name_en` LIKE '%" + this.model['name_en'] + "%') ";

    if (this.model['branch_id'] != '0')
      condition += " AND `employee`.`branch_id` = '" + this.model['branch_id'] + "'";

    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user_name` != 'mas'";

    let query = "SELECT `user`.*, `branch`.`branch_name`, `branch`.`branch_name_en`, `employee`.`name`, " + 
      "`employee`.`name_en` FROM `user`, `branch` , `employee` WHERE `user`.`employee_no` = `employee`.`employee_no` AND " +
      "`employee`.`branch_id` = `branch`.`branch_id`" + condition;

    console.log(query);
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let counter = 0;
        this.dp = data.data['list'];
        if (this.dp.length > 0) {
          this.dp.forEach(element => {
            if (element.is_counter == '1') {
              let query2 = "SELECT * FROM `acct_base` WHERE `acct_number` = '" + element['acct_number'] + "'";
              let obj2 = { cmd: 'getList', query: query2 };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  element.baseline_amount = data.data['list']['0']['baseline_amount'];

                  counter++;
                  if (counter == this.dp.length)
                    this.fillMatTable();
                });
            }
            else {
              element.baseline_amount = this.Not_Casher;
              counter++;
              if (counter == this.dp.length)
                this.fillMatTable();
            }

          });
        }
        else
          this.fillMatTable();
      });
  }

  fillMatTable() {
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  newUser() {
    this.addDialogRef = this.dialog.open(UserComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // console.log(result);
        if (result != null && result['op_type'] == 'success') {
          this.checkUserCount();
          this.search();
        }
      });
  }

  branch_auth(row) {
    let dialog_data = [{
      'user_id': row.user_id,
      'user_name': row.user_name,
      'employee_no': row.employee_no,
      'acct_number': row.acct_number,
    }, { 'name': row.name, 'name_en': row.name_en }];

    this.authDialogRef = this.dialog.open(BranchAuthComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.authDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success')
        //   this.search();
      });
  }

  editUser(row) {
    // let iscounter = 0;
    // if (row.is_counter == '1')
    //   iscounter = 1;
    let dialog_data = [{
      'table_name': 'user', 'user_id': row.user_id,
      'user_full_name': '',
      'user_name': row.user_name,
      'user_password': row.user_password,
      'employee_no': row.employee_no,
      'role': row.role,
      'user_email': row.user_email,
      'is_counter': row.is_counter,
      'flag': 'update',
      'key': 'user_id',
      'acct_number': row.acct_number,
      'comment': row.comment
    }, { 'name': row.name, 'name_en': row.name_en }];

    this.addDialogRef = this.dialog.open(UserComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delUser(row) {
    let values = [];
    let where = [];
    let obj;

    if (row.status == '1') {
      if (confirm(this.Del_Msg)) {

        values.push({ 'table_name': this.model['table_name'], 'user_id': row.user_id });
  
        if (row.acct_number != '')
          values.push({ 'table_name': 'sub_acct', 'acct_number': row.acct_number });
  
        obj = { cmd: 'deleteRec', values: values };
  
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.search();
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }
    else {
      values.push({ 'table_name': this.model['table_name'], 'status': '1' });
      where.push({ 'user_id': row.user_id });

      if (row.acct_number != '') {
        values.push({ 'table_name': 'sub_acct', 'status': '1' });
        where.push({ 'acct_number': row.acct_number });
      }

      obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else
            alert(this.Error_Msg);
        });
    }
  }

  change_pass(row) {
    let dialog_data = {
      'user_id': row.user_id
    };
    this.changeDialogRef = this.dialog.open(ChangePasswordComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.changeDialogRef
      .afterClosed()
      .subscribe(result => {
      });
  }


}
